'use strict';

import React from 'react';

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import ModalContent from '@Modal/ModalContent'

export default class Modal extends React.Component
{
	constructor (props)
	{
		super(props);

		this.close        = this.close.bind(this);
		this.handleAction = this.handleAction.bind(this);

		this.state =
		{
			id: ++window.app.state.modal_id
		};
	}

	handleAction (e)
	{
		const component = this, props = this.props;

		if (props.type === 'conversation' || props.type === 'spam-conversation')
		{
			app.emit('open__MessageSpamModal',
			{
				customer_id: props.customer_id,
				is_spam: props.is_spam
			});
		}
	}

	close (e)
	{
		const component = this, props = this.props;

		e.stopPropagation();

		app.emit('documentClick');

		app.state.modal_open = false;

		props.onClose(e);

		window.setTimeout(function ()
		{
			app.state.open_modals = app.state.open_modals.filter(function (id)
			{
				return id !== component.state.id;
			});

			if (app.state.open_modals.length === 0)
			{
				document.body.classList.remove('modal-open');
			}
		}, 320);
	}

	componentDidUpdate ()
	{
		const component = this, props = this.props;

		var modal;

		if (props.open === true)
		{
			if (navigator.userAgent.indexOf('MSIE') !== -1 ||
				navigator.appVersion.indexOf('Trident/') > 0)
			{
				var evt = document.createEvent('UIEvents');

				evt.initUIEvent('resize', true, false, window, 0);

				window.dispatchEvent(evt);
			}
			else
			{
				window.dispatchEvent(new Event('resize'));
			}

			modal = app.state.open_modals.find(function (id)
			{
				return id === component.state.id;
			});

			if (!modal)
			{
				app.state.open_modals.push(component.state.id);
			}
		}
	}

	render ()
	{
		const component = this, props = this.props;

		var class_name = props.className || 'o-modal';
		var modal_content, modal_overlay;

		if (props.open === true)
		{
			class_name += ' o-modal--open';

			modal_overlay =
			(
				<CSSTransition
					classNames="a-overlay-transition"
					appear={ true }
					enter={ true }
					exit={ true }
					timeout={{ enter: 240, exit: 320 }}>

					<div className="o-overlay o-overlay--modal"></div>
				</CSSTransition>
			);

			modal_content =
			(
				<CSSTransition
					classNames="a-modal-transition"
					appear={ true }
					enter={ true }
					exit={ true }
					timeout={{ enter: 320, exit: 320 }}>

					<div className={ class_name }>
						<ModalContent onClose={ component.close }
							title={ props.title } invisible={ props.invisible }
							hide_close={ props.hide_close } type={ props.type }
							onAction={ component.handleAction }>
							{ props.children }
						</ModalContent>

					</div>

				</CSSTransition>
			);
		}

		var output =
		(
			<TransitionGroup className="modal-container">

				{ modal_overlay }

				{ modal_content }

			</TransitionGroup>
		);

		return output;
	}
}